/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useMemo } from 'react'

import type { SecurityProductType } from '@modules/project-user-api/v1/types'
import { includesProductType } from '@modules/project-lib/securityProjectTypes'

import { useFlagsWhenLoaded } from '../../launchdarkly'
import { PRODUCT_TYPES } from '../../project-components/ProjectPage/ProductDefinition'

export const useSearchAILakeAvailable = (
  existingProjectProductTypes?: SecurityProductType[] | undefined,
) => {
  const [isFlagUsable, { aiForSecurityOpsCenter }] = useFlagsWhenLoaded()
  const isCurrentComplete = useMemo(
    () =>
      existingProjectProductTypes &&
      includesProductType(existingProjectProductTypes, PRODUCT_TYPES.complete.security.obj),
    [existingProjectProductTypes],
  )
  const isCurrentEssentials = useMemo(
    () =>
      existingProjectProductTypes &&
      includesProductType(existingProjectProductTypes, PRODUCT_TYPES.essentials.security.obj),
    [existingProjectProductTypes],
  )
  const isSearchAILakeAvailable =
    isFlagUsable && aiForSecurityOpsCenter && !isCurrentComplete && !isCurrentEssentials

  return useMemo(
    () => ({ isFlagUsable, aiForSecurityOpsCenter, isSearchAILakeAvailable }),
    [isFlagUsable, aiForSecurityOpsCenter, isSearchAILakeAvailable],
  )
}
